import { Customization, GeneralSetting } from '@/webapi/use-widget-catalog-api';

export enum StyleTemplateDevice {
  M = `M`,
  D = `D`,
}
export enum StyleTemplateType {
  CUSTOM = `CUSTOM`,
  DEFAULT = `DEFAULT`,
  EDIT_LATEST = `EDIT_LATEST`,
  PUBLISH_LATEST = `PUBLISH_LATEST`,
}

export type StyleTemplate = {
  id: string;
  name: string;
  type: StyleTemplateType;
  appId: string;
  device: StyleTemplateDevice;
  widgetName: string;
  props: { customizations: Array<Customization> };
  generalSettings?: GeneralSetting;
  isGlobal?: boolean;
};
export type StoreStyles = {
  humanEdited?: boolean;
  atcAttributes: {
    textColor: string;
    boxShadow: string;
    border: string;
    borderRadius: string;
    bgColor: string;
  };
  imageAttributes: {
    boxShadow: string;
    border: string;
    borderRadius: string;
  };
  pdpTitleAttrs?: {
    fontFamily?: string;
    fontSize?: string;
    fontWeight?: string;
    color?: string;
    lineHeight?: string;
    textTransform?: string;
    textAlign?: string;
  };
  inner?: {
    buttons?: {
      primary?: ButtonStyle;
      secondary?: ButtonStyle;
    };
    typography?: {
      title?: TypographyStyle;
      subtitle?: TypographyStyle;
    };
    images?: {
      default?: ImageStyle;
    };
    containers?: {
      default?: ContainerStyle;
    };
  };
};

export type ButtonStyle = {
  textColor?: string;
  bgColor?: string;
  border?: string;
  borderRadius?: string;
  boxShadow?: string;
};

export type TypographyStyle = {
  color?: string;
  fontSize?: string;
  fontWeight?: string;
  fontFamily?: string;
  lineHeight?: string;
  textTransform?: string;
  textAlign?: string;
};

export type ImageStyle = {
  border?: string;
  borderRadius?: string;
  boxShadow?: string;
};

export type ContainerStyle = {
  background?: string;
  border?: string;
  borderRadius?: string;
  boxShadow?: string;
  padding?: string;
};
export type StyleTemplates = {
  templates: Array<StyleTemplate>;
  storeStyles?: StoreStyles;
};
